import type { CustomerModel } from "./CustomerModel";
import type {
  ZekayCustomer,
  CustomersPaginationRequest,
  SearchCustomersRequest,
} from "./Customer.typed";
import type { Excursion } from "../excursions/Excursion.typed";
import type { PaginatedResponse } from "../zekay/pagination";
export class CustomerAdapter {
  constructor(private model: CustomerModel) {}

  async getCustomers(
    paginationParams?: CustomersPaginationRequest,
  ): Promise<PaginatedResponse<ZekayCustomer> | ZekayCustomer[]> {
    return this.model.getCustomers(paginationParams);
  }

  async getCustomer(id: string): Promise<ZekayCustomer | undefined> {
    return this.model.getCustomer(id);
  }

  async createCustomer(payload: ZekayCustomer): Promise<ZekayCustomer> {
    return this.model.createCustomer(payload);
  }

  async deleteCustomer(id: number): Promise<void> {
    return this.model.deleteCustomer(id);
  }

  async updateCustomer(id: number, payload: ZekayCustomer): Promise<ZekayCustomer> {
    return this.model.updateCustomer(id, payload);
  }

  async updateFile(formData: FormData): Promise<void> {
    return this.model.updateFile(formData);
  }

  async deleteCustomerFile(payload: {
    CustomerID: number;
    Type: "photo" | "medical";
  }): Promise<void> {
    return this.model.deleteCustomerFile(payload);
  }

  async getCustomersBatch(ids: number[]): Promise<ZekayCustomer[]> {
    return this.model.getCustomersBatch(ids);
  }

  async searchCustomers(searchRequest: SearchCustomersRequest): Promise<ZekayCustomer[]> {
    return this.model.searchCustomers(searchRequest);
  }

  async getCustomerExcursions(
    customerId: number,
    page?: number,
    limit?: number,
  ): Promise<PaginatedResponse<Excursion>> {
    return this.model.getCustomerExcursions(customerId, page, limit);
  }
}
